import { DEFAULT_ANALYTICS_FILTERING, iconMap } from '@/utils/constants'
import { IconButton } from '@/components'
import { useAnalyticsFiltersGetParams } from '@/features/Analytics/hooks/useAnalyticsFiltersGetParams'
import { useTranslation } from 'react-i18next'
import { useDashboardUsageAndCostFiltersStore } from '@/stores/useDashboardUsageAndCostFiltersStore'

const UsageAndCostTitle = () => {
    const { t } = useTranslation('translations')
    const activeFilters = useDashboardUsageAndCostFiltersStore(
        (state) => state.activeFilters
    )
    const filters = useAnalyticsFiltersGetParams(activeFilters)
    const commodityTypeId = Number(
        filters.commodityTypeId ?? DEFAULT_ANALYTICS_FILTERING.commodity[0]
    )

    return (
        <div className="flex items-center gap-4">
            <IconButton
                name="commodity-icon"
                icon={iconMap[commodityTypeId] || 'info'}
                size="large"
                iconSize="smedium"
                data-testid={`commodity-${commodityTypeId.toString()}-icon`}
                variant="ghostPrimary"
                className="!bg-blue-50 !text-azure"
            />
            <h6 className="text-heading-6 capitalize leading-6 text-regular">
                {t('dashboard.usage_cost_title')}
            </h6>
        </div>
    )
}

export default UsageAndCostTitle
